// extracted by mini-css-extract-plugin
export default {"backdrop":"Modalh_backdrop__f7fOB","modal":"Modalh_modal__50+vu","slide-down":"Modalh_slide-down__57wP5"};